import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'react-final-form';
import {Checkbox, FormControl} from '@tenancy.nz/ui';
import {getFieldProps} from '../utils/helpers';

function CheckboxField({label, name, validate = undefined}) {
  return (
    <Field name={name} type="checkbox" validate={validate || null}>
      {({input, meta}) => (
        <FormControl {...getFieldProps({input: {}, meta})}>
          <Checkbox
            color="tertiary"
            id={name}
            label={label}
            {...getFieldProps({input, meta: {}})}
          />
        </FormControl>
      )}
    </Field>
  );
}

CheckboxField.propTypes = {
  label: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  validate: PropTypes.func,
};

export default CheckboxField;
